<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";
import { required, requiredIf, minLength, maxLength, url } from "vuelidate/lib/validators"; // for validators
import {swal} from '../../../helpers/handle_error.js';
import AlertError from '@/components/alert_error'
import Video from '../../../model/video.js';
import { VueContentLoading } from 'vue-content-loading';

export default {
  page: {
    title: "المكتبة الفيديوية",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, AlertError, VueContentLoading },
  data() {
    return {
     
      title: "تعديل الفيديو",
      items: [
        {
          text: "المكتبة الفيديوية",
          href: "/videos",
        },
        {
          text: "تعديل الفيديو",
          active: true,
        },
      ],

      //Page errors.
      errors: [],

      id: this.$route.params.id,
      video: new Video,
      submitadd: false,
      loadingButton: false,
      loadingContent: false
    };
  },
  validations: {
    video: {
      title_ar: {required: requiredIf(function (){ return this.checkLocale('ar'); }), minLength: minLength(2), maxLength: maxLength(300) },
      title_en: {required: requiredIf(function (){ return this.checkLocale('en'); }), minLength: minLength(2), maxLength: maxLength(300) },
      title_fa: {required: requiredIf(function (){ return this.checkLocale('fa'); }), minLength: minLength(2), maxLength: maxLength(300) },
      locales: {required},
      video_url: {required, url, maxLength: maxLength(500) },
    },
  },
   computed:{
    ...mapGetters('video', ['getVideo' ])
  },
  methods: {
    ...mapActions("video", ['get', 'edit']),
    handleError(error){
      alert(error)
      if(error.response.status == 422) this.errors = Object.values(error.response.data.errors)
      else this.errors = [`Error Code : ${error.response.status}  Message : ${error.response.data.message}`]
    },
    checkLocale(locale){
      return this.video.locales.includes(locale);
    },
    checkValidate(){
      return !this.$v.video.locales.$error &&
        (!this.checkLocale('ar') || !this.$v.video.title_ar.$error) && 
        (!this.checkLocale('en') || !this.$v.video.title_en.$error) && 
        (!this.checkLocale('fa') || !this.$v.video.title_fa.$error) &&
        !this.$v.video.video_url.$error
    },
    formEditVideo(published = false) {
      this.submitadd = true;
      this.$v.$touch();
      if(!this.checkValidate()) return;

      // to form submit after this
      this.loadingButton = true
      this.errors = [];
      
      this.video.published = published

      this.edit({
        id: this.id,
        video: this.video.toFormData()
      })
      .then((response)=>{
        swal.success(response.data.message)
        this.loadingButton = false
      })
      .catch((error)=>{
        this.handleError(error)
        this.loadingButton = false
      })
    }
  },
  created(){
    this.get(this.id)
    .then(()=>{
      this.video = this.getVideo
      this.loadingContent = true
    })
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">

      <div class="col-md-12">
        <div class="card">
          <div class="card-body">

            <b-form v-if="loadingContent">

              <AlertError :errors="errors"></AlertError>

              <div class="row mt-3">

                <b-form-group class="col-md-12 mb-3" label="لغة الفيديو :">
                  <b-form-checkbox class="dis-inline" v-model="video.locales" value="ar" plain>عربي</b-form-checkbox>
                  <b-form-checkbox class="dis-inline" v-model="video.locales" value="en" plain>انكليزي</b-form-checkbox>
                  <!-- <b-form-checkbox class="dis-inline" v-model="video.locales" value="fa" plain>فارسي</b-form-checkbox> -->
                  <div v-if="submitadd && $v.video.locales.$error" class="invalid-check">
                    <span v-if="!$v.video.locales.required"> يجب اختيار لغة واحدة على الاقل </span>
                  </div>
                </b-form-group>

                <b-form-group class="col-md-12 mb-3" label="رابط الفيديو : " label-for="video_url" >
                  <b-form-input id="video_url" v-model="video.video_url" :class="{ 'is-invalid': submitadd && $v.video.video_url.$error }" placeholder="ادخل رابط الفيديو" type="url" ></b-form-input>
                  <div v-if="submitadd && $v.video.video_url.$error" class="invalid-feedback">
                    <span v-if="!$v.video.video_url.required"> هذا الحقل الزامي </span>
                    <span v-if="!$v.video.video_url.url"> يجب أن تكون هذه القيمة عنوان url صالحًا. </span>
                    <span v-if="!$v.video.video_url.maxLength"> قيمة هذا الحقل طويلة جداً. يجب ان يتكون من 500 حرف على الاكثر . </span>
                  </div>
                </b-form-group>

                <b-form-group v-if="checkLocale('ar')" class="col-md-12 mb-3 class_ar" label="عنوان الفيديو : ( عربي )" label-for="title_ar" >
                  <b-form-input id="title_ar" v-model.trim="video.title_ar" :class="{ 'is-invalid': submitadd && $v.video.title_ar.$error }" placeholder="ادخل عنوان الفيديو" type="text" ></b-form-input>
                  <div v-if="submitadd && $v.video.title_ar.$error" class="invalid-feedback">
                    <span v-if="!$v.video.title_ar.required"> هذا الحقل الزامي </span>
                    <span v-if="!$v.video.title_ar.minLength"> قيمة هذا الحقل قصيرة جداً. يجب ان يتكون من 2 احرف على الاقل . </span>
                    <span v-if="!$v.video.title_ar.maxLength"> قيمة هذا الحقل طويلة جداً. يجب ان يتكون من 300 حرف على الاكثر . </span>
                  </div>
                </b-form-group>

                <b-form-group v-if="checkLocale('ar')" class="col-md-12 mb-3 class_ar" label="وصف الفيديو : ( عربي )" label-for="description_ar">
                  <textarea id="description_ar" v-model="video.description_ar" class="form-control" rows="5" ></textarea>
                </b-form-group>

                <b-form-group v-if="checkLocale('en')" class="col-md-12 mb-3 class_en" label="عنوان الفيديو : ( انجليزي )" label-for="title_en" >
                  <b-form-input id="title_en" v-model.trim="video.title_en" :class="{ 'is-invalid': submitadd && $v.video.title_en.$error }" placeholder="ادخل عنوان الفيديو" type="text" ></b-form-input>
                  <div v-if="submitadd && $v.video.title_en.$error" class="invalid-feedback">
                    <span v-if="!$v.video.title_en.required"> هذا الحقل الزامي </span>
                    <span v-if="!$v.video.title_en.minLength"> قيمة هذا الحقل قصيرة جداً. يجب ان يتكون من 2 احرف على الاقل . </span>
                    <span v-if="!$v.video.title_en.maxLength"> قيمة هذا الحقل طويلة جداً. يجب ان يتكون من 300 حرف على الاكثر . </span>
                  </div>
                </b-form-group>

                <b-form-group v-if="checkLocale('en')" class="col-md-12 mb-3 class_en" label="وصف الفيديو : ( انجليزي )" label-for="description_en" >
                  <textarea id="description_en" v-model="video.description_en" class="form-control" rows="5" ></textarea>
                </b-form-group>

                <b-form-group v-if="checkLocale('fa')" class="col-md-12 mb-3 class_fa" label="عنوان الفيديو : ( فارسي )" label-for="title-fa" >
                  <b-form-input id="title-fa" v-model.trim="video.title_fa" :class="{ 'is-invalid': submitadd && $v.video.title_fa.$error }" placeholder="ادخل عنوان الفيديو" type="text" ></b-form-input>
                  <div v-if="submitadd && $v.video.title_fa.$error" class="invalid-feedback">
                    <span v-if="!$v.video.title_fa.required"> هذا الحقل الزامي </span>
                    <span v-if="!$v.video.title_fa.minLength"> قيمة هذا الحقل قصيرة جداً. يجب ان يتكون من 2 احرف على الاقل . </span>
                    <span v-if="!$v.video.title_fa.maxLength"> قيمة هذا الحقل طويلة جداً. يجب ان يتكون من 300 حرف على الاكثر . </span>
                  </div>
                </b-form-group>

                <b-form-group v-if="checkLocale('fa')" class="col-md-12 mb-3 class_fa" label="وصف الفيديو : ( فارسي )" label-for="description_fa" >
                  <textarea id="description_fa" v-model="video.description_fa" class="form-control" rows="5" ></textarea>
                </b-form-group>

              </div>

              <div class="mt-3">
                <hr>
                <b-button :disabled="loadingButton" @click="formEditVideo(false)" variant="primary" type="button" class="me-2"> 
                  <b-spinner v-if="loadingButton && !video.published" small></b-spinner>
                  <span v-else><i class="bx bx-check font-size-16 align-middle me-2"></i>حفظ</span>
                </b-button>

                <b-button :disabled="loadingButton" @click="formEditVideo(true)" variant="success" type="button"> 
                  <b-spinner v-if="loadingButton && video.published" small></b-spinner>
                  <span v-else><i class="bx bx-paper-plane font-size-16 align-middle me-2"></i>نشر</span>
                </b-button>

                <b-button class="f-left" type="button" to="/videos" variant="secondary">رجوع</b-button>
              </div>

            </b-form>
            
            <!-- loading content -->
            <div v-else>
              <vue-content-loading :rtl="true" :width="400" :height="250">
                <rect x="0" y="4" rx="1" ry="1" width="50" height="2" />
                <rect x="0" y="8" rx="1" ry="1" width="4" height="4" />
                <rect x="6" y="10" rx="1" ry="1" width="10" height="1" />
                <rect x="20" y="08" rx="1" ry="1" width="4" height="4" />
                <rect x="26" y="10" rx="1" ry="1" width="10" height="1" />
                <rect x="40" y="8" rx="1" ry="1" width="4" height="4" />
                <rect x="46" y="10" rx="1" ry="1" width="10" height="1" />

                <rect x="0" y="18" rx="1" ry="1" width="50" height="2" />
                <rect x="0" y="22" rx="1" ry="1" width="400" height="10" />
                <rect x="0" y="37" rx="1" ry="1" width="50" height="2" />
                <rect x="0" y="41" rx="1" ry="1" width="400" height="10" />
                <rect x="0" y="56" rx="1" ry="1" width="50" height="2" />
                <rect x="0" y="60" rx="1" ry="1" width="400" height="35" />

                <rect x="0" y="100" rx="1" ry="1" width="50" height="2" />
                <rect x="0" y="104" rx="1" ry="1" width="400" height="10" />
                <rect x="0" y="119" rx="1" ry="1" width="50" height="2" />
                <rect x="0" y="123" rx="1" ry="1" width="400" height="35" />

                <rect x="0" y="163" rx="1" ry="1" width="50" height="2" />
                <rect x="0" y="167" rx="1" ry="1" width="400" height="10" />
                <rect x="0" y="182" rx="1" ry="1" width="50" height="2" />
                <rect x="0" y="186" rx="1" ry="1" width="400" height="35" />

                <rect x="0" y="229" rx="1" ry="1" width="400" height="1" />
                <rect x="0" y="234" rx="1" ry="1" width="20" height="10" />
                <rect x="22" y="234" rx="1" ry="1" width="20" height="10" />
                <rect x="385" y="234" rx="1" ry="1" width="15" height="10" />
              </vue-content-loading>
            </div>

          </div>
        </div>
      </div>
                    
    </div>
    
  </Layout>
</template>